import { stringify } from 'query-string';

export const rolesDataProvider = context => {
    const rolePath = `${context.apiUrl}/developerRoleTypes`; // GET ONE - GET LIST
    return {
        getList: async () => {
            const url = `${rolePath}?${stringify({
                status: 'ENABLED',

            })}`;
            const { json } = await context.fetchJson(url, {
                credentials: 'include',
            });

            return {
                data:
                    json.developerRoleTypes.map(({ uuid, ...item }) => ({
                        ...item,
                        id: uuid,
                    })) || [],
                total: json.totalElements || 0,
            };
        },
    };
};
